import { PaymentMethod } from "@mimber/schema"

export const PAYMENT_METHOD_OPTIONS = [
  { label: "Card", value: PaymentMethod.CARD },
  { label: "ACH", value: PaymentMethod.ACH },
  { label: "Cash", value: PaymentMethod.CASH },
  { label: "Check", value: PaymentMethod.CHECK },
  { label: "Venmo", value: PaymentMethod.VENMO },
  { label: "Zelle", value: PaymentMethod.ZELLE },
  { label: "PayPal", value: PaymentMethod.PAYPAL },
  { label: "Cash App", value: PaymentMethod.CASH_APP },
  { label: "Other", value: PaymentMethod.OTHER },
]
